import React, {Component} from "react";
import "./AdditionalDetails.css";

class AdditionalDetails extends Component {
	render(){
		return(
			<section className="section indigo lighten-5 center">
			<h4 className="revealThis">Additional <strong className="indigo-text darken-4">Technologies</strong></h4>
			<div className="revealThis"><h7>Click on a category to see more!</h7></div>
			<div className="container">
				<div className="row revealThis">
					<div className="col s12 m8 offset-m2">
						<ul className="collapsible">
							<li>
								<div className="collapsible-header"><i className="material-icons">computer</i>Front-End Technologies</div>
								<div className="collapsible-body white left-align">
									<table className="striped">
										<tbody>
											<tr><td>Javascript ES5/ES6</td></tr>
											<tr><td>Python 3</td></tr>
											<tr><td>HTML5</td></tr>
											<tr><td>CSS</td></tr>
											<tr><td>CSS Animation</td></tr>
											<tr><td>Bootstrap</td></tr>
											<tr><td>Materialize CSS/UI</td></tr>
											<tr><td>JQuery</td></tr>
											<tr><td>Embedded Javascript (EJS)</td></tr>

										</tbody>
									</table>
								</div>
							</li>
							<li>
								<div className="collapsible-header"><i className="material-icons">build</i>Back-End Technologies</div>
								<div className="collapsible-body white left-align">
									<table className="striped">
										<tbody>
											<tr><td>Python 3</td></tr>
											<tr><td>Flask/Alchemy</td></tr>
											<tr><td>Passport</td></tr>
											<tr><td>CORS</td></tr>
											<tr><td>Jsonwebtoken</td></tr>
											<tr><td>Axios</td></tr>
											<tr><td>Bcrypt</td></tr>
										</tbody>
									</table>
								</div>
							</li>
							<li>
								<div className="collapsible-header"><i className="material-icons">sports_esports</i>Game Development</div>
								<div className="collapsible-body white left-align">
									<table className="striped">
										<tbody>
											<tr><td>C#</td></tr>
											<tr><td>Unity 2D/3D</td></tr>
											<tr><td>HTML5 Canvas</td></tr>

										</tbody>
									</table>
								</div>
							</li>
							<li>
								<div className="collapsible-header"><i className="material-icons">devices_other</i>Other Technologies</div>
								<div className="collapsible-body white left-align">
									<table className="striped">
										<tbody>
											<tr><td>Github</td></tr>
											<tr><td>Agile Project Management</td></tr>
											<tr><td>Heroku</td></tr>
											<tr><td>Godaddy</td></tr>
											<tr><td>Trello</td></tr>
											<tr><td>Asana</td></tr>
										</tbody>
									</table>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			</section>
		)
	}
}

export default AdditionalDetails;


// WEBPACK FOOTER //
// ./src/components/AdditionalDetails/AdditionalDetails.js